import {
  requestType,
  succeedType,
  failedType,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_GET_POLICY,
} from "./../actions/actionTypes";

const initState = {
  error: false,
  loading: false,
  change_password_message: "",
  change_password_data: {},
};

export const changePasswordReducer = (state = initState, action) => {
  switch (action.type) {
    case requestType(CHANGE_PASSWORD):
    case requestType(CHANGE_PASSWORD_GET_POLICY):
      return {
        ...state,
        error: false,
        loading: true,
      };
    case failedType(CHANGE_PASSWORD):
    case failedType(CHANGE_PASSWORD_GET_POLICY):
      return {
        ...state,
        error: true,
        loading: false,
      };
    case succeedType(CHANGE_PASSWORD):
      return {
        ...state,
        error: false,
        loading: false,
        change_password_message: action.change_password_message,
      };
    case succeedType(CHANGE_PASSWORD_GET_POLICY):
      return {
        ...state,
        error: false,
        loading: false,
        change_password_data: action.change_password_data,
      };
    default:
      return state;
  }
};
